import "core-js/modules/web.dom.iterable";
/**重置message，防止重复点击重复弹出message弹框 */
import { Message } from 'element-ui';
var messageInstance = null;
var resetMessage = function resetMessage(options) {
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message(options);
};
['error', 'success', 'info', 'warning'].forEach(function (type) {
  resetMessage[type] = function (options) {
    if (typeof options === 'string') {
      options = {
        message: options
      };
    }
    options.type = type;
    return resetMessage(options);
  };
});
export var message = resetMessage;